import React from "react";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";

import "./styles/works.css";

const Works = () => {
	return (
		<div className="works">
			<Card
				icon={faBriefcase}
				title="Work"
				body={
					<div className="works-body">
						<div className="work">
							<img
								src="./st-logo.png"
								alt="Signal-Tech"
								className="work-image"
							/>
							<div className="work-title">Signal-Tech</div>
							<div className="work-subtitle">
								Full-stack Web Developer
							</div>
							<div className="work-duration">2013 - Present</div>
						</div>

						<div className="work">
							<img
								src="./id-logo.jpg"
								alt="iDesign, Inc"
								className="work-image"
							/>
							<div className="work-title">iDesign, Inc</div>
							<div className="work-subtitle">
								Senior Web Developer
							</div>
							<div className="work-duration">2012 - 2013</div>
						</div>
					</div>
				}
			/>
		</div>
	);
};

export default Works;
